import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import { CollectPointModel } from '../model/CollectPointModel.js';

export default {
    apiCollectPoint: function (codes) {
        const token = Account.getToken();
        const pointCode = JSON.stringify(codes).replace(/[[\]"]/g, '');
        const params = {
            'codes[]': pointCode
        };

        const url = ConfigManager.getApiModuleUrl() + '/coupon/process';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            const codes = res.data;
            let result = [];
            for (let code of codes) {
                const collectpoint = new CollectPointModel(code, codes[code]);
                result.pust(collectpoint);
            }

            return result;
        }));
    },
    apiGetCodeByQRCode: function (file) {
        const token = Account.getToken();
        const url = ConfigManager.getApiUrl() + '/api/ocr';
        return BzbsApi.connectBzbsPost(url, token, null, 'image', file).pipe(map((res) => {
            return res.data;
        }));
    }
}